// src/translations.js

const translations = {
    marathi: {
        nameLabel: "कृपया तुमचे नाव भरा.",
        womenLabel: "तुमच्या कुटुंबात किती महिला सदस्य आहेत?",
        commuteLabel: "तुमच्या कुटुंबातील महिलांचा स्थानिक प्रवासासाठी मासिक सरासरी खर्च किती आहे?",
        lpgCylindersLabel: "तुम्ही एका महिन्यात किती LPG सिलिंडर वापरता?",
        healthcareLabel: "तुमच्या कुटुंबाचा मासिक आरोग्य खर्च किती आहे?",
        employmentLabel: "तुमच्या कुटुंबात किती लोक पदवीधर/डिप्लोमा धारक आहेत पण बेरोजगार आहेत?",
        debtLabel: "तुमच्या कुटुंबाचा शेती कर्जाचा मासिक हप्ता किती आहे? (जर असेल तर)",
        electricityLabel: "तुमचा मासिक वीज बिलाचा खर्च किती आहे?",
        submitButton: "बचत गणना करा.",
        namePlaceHolder: "नाम",
        errorLabel: "कृपया सर्व आवश्यक फील्ड योग्यरित्या भरा",
        annualLabel: (saving) => `तुमची वार्षिक बचत - ₹ ${saving}`,
        whatsappShareButton: "व्हाट्सएप वर शेअर करा",
        halfDecLabel: (saving) => `तुमची पंचवार्षिक बचत - ₹ ${saving}`,
        resultLabel: (name) => `${name} जी, महाराष्ट्रात लवकरच महाविकास आघाडी सरकार आल्यावर`,
        waShareText: (saving) => `महाराष्ट्रात महाविकास आघाडीचे सरकार आल्यास माझ्या कुटुंबाची वार्षिक बचत ₹ ${saving} होईल. तुमच्या कुटुंबाची बचत जाणून घेण्यासाठी या लिंकवर क्लिक करा: https://mvamahabachatcalculator.com`
    },
    hindi: {
        nameLabel: "कृपया अपना नाम भरें.",
        womenLabel: "आपके परिवार में कितनी महिला सदस्य हैं?",
        commuteLabel: "आपके परिवार की महिलाओं का स्थानीय यात्रा पर मासिक औसत खर्च क्या है?",
        lpgCylindersLabel: "आप एक महीने में कितने LPG सिलेंडर का उपयोग करते हैं?",
        healthcareLabel: "आपके परिवार का मासिक स्वास्थ्य खर्च कितना है?",
        employmentLabel: "आपके परिवार में कितने लोग स्नातक/डिप्लोमा धारक हैं लेकिन बेरोजगार हैं?",
        debtLabel: "आपके परिवार का कृषि ऋण की मासिक किस्त कितनी है? (यदि लागू हो)",
        electricityLabel: "आपका मासिक बिजली बिल खर्च कितना है?",
        submitButton: "बचत की गणना करें।",
        namePlaceHolder: "नाम",
        errorLabel: "कृपया सभी आवश्यक फ़ील्ड सही ढंग से भरें",
        annualLabel: (saving) => `आपकी वार्षिक बचत - ₹ ${saving}`,
        whatsappShareButton: "व्हाट्सएप पर शेयर करें ",
        halfDecLabel: (saving) => `आपकी पंचवर्षीय बचत - ₹ ${saving}`,
        resultLabel: (name) => `${name} जी, महाराष्ट्र में जल्द ही महाविकास अघाड़ी सरकार आने पर`,
        waShareText: (saving) => `महाराष्ट्र में *महाविकास अघाड़ी* की सरकार बनने पर मेरे  परिवार की *वार्षिक बचत ₹${saving}* तक हो होगीै। अपने *परिवार की बचत जानने के लिए* इस लिंक पर क्लिक करें:  https://mvamahabachatcalculator.com`


    },
    english: {
        nameLabel: "Please enter your name.",
        womenLabel: "How many female members are in your family?",
        commuteLabel: "What is your family's average monthly expense on local travel for women?",
        lpgCylindersLabel: "How many LPG cylinders do you use in a month?",
        healthcareLabel: "What is your family's monthly healthcare expense?",
        employmentLabel: "How many members in your family are graduates/diploma holders but unemployed?",
        debtLabel: "What is your family's monthly agricultural loan installment? (if any)",
        electricityLabel: "What is your monthly electricity bill expense?",
        submitButton: "Calculate Savings.",
        namePlaceHolder: "Name",
        errorLabel: "Please fill all required fields correctly",
        annualLabel: (saving) => `Your Annual savings will be -₹ ${saving}`,
        whatsappShareButton: "Share on Whatsapp",
        halfDecLabel: (saving) => `Your Five-yearly savings will be -₹ ${saving}`,
        resultLabel: (name) => `Dear ${name}, When the MVA Government comes to power in Maharashtra`,
        waShareText: (saving) => `With the government of *Maha Vikas Aghadi* in Maharashtra, my family will *save upto ₹${saving}*. Click on this link to *know your family savings*: https://mvamahabachatcalculator.com`

    }
};

export default translations;
